// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Qdo4k","calendarButtons":"ClockData_calendarButtons__1UK7I"};